
export function ResearchDevelopmentQualityEchartOp ({ v, data }) {
  console.log(data)
  let ResearchDevelopmentQualityData = configResearchDevelopmentQualityData(data)
  let options = {
    // color: ['rgba(255, 95, 165, 1)', 'rgba(0, 114, 255, 1)', 'rgba(50, 14, 55, 1)', 'rgba(100, 114, 55, 1)'],
    grid: {
      left: '5%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      data: ResearchDevelopmentQualityData.xAxisData,
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.4)'
        }
      }
    },
    series: ResearchDevelopmentQualityData.seriesData
  }
  return options
}

function configResearchDevelopmentQualityData (data) {
  console.log(data)
  let xAxisData = data?.slaMap?.list?.date ?? []
  // xAxisData = xAxisData || []
  let seriesData = (data?.slaMap?.list?.data ?? []).reduce((a, b) => {
    b.forEach(aItem => {
      if (!a[aItem.serverName]) {
        a[aItem.serverName] = {
          name: aItem.serverName,
          data: [aItem.slaRate],
          type: 'line',
          smooth: true,
          symbol: 'none'
        }
      } else {
        a[aItem.serverName].data.push(aItem.slaRate)
      }
    })
    return a
  }, {}) ?? {}
  return {
    xAxisData,
    seriesData: Object.values(seriesData)
  }
}
// ---------
export function ResearchDevelopmentQualityOtherEchartOp ({ v, data }) {
  let options = {
    color: ['#3198f7', 'rgba(255, 95, 165, 1)', 'rgba(0, 114, 255, 1)'],
    grid: {
      left: '5%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      data: data?.avg?.date ?? [],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: [{
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.4)'
        }
      },
      alignTicks: true
    },
    {
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.4)'
        }
      }
    }],
    series: [
      {
        data: data?.total?.data ?? [],
        type: 'bar',
        smooth: true,
        symbol: 'none'
      },
      {
        yAxisIndex: 1,
        data: data?.avg?.data ?? [],
        type: 'line',
        smooth: true,
        symbol: 'none'
      }
    ]
  }
  return options
}
export function DataPlatformEfficiencyEchartOp ({ v, data }) {
  let options = {
    color: ['#3198f7', 'rgba(255, 95, 165, 1)', 'rgba(0, 114, 255, 1)'],
    grid: {
      left: '5%',
      top: '23%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['日均查询次数', '平均每次查询时长/min'],
      textStyle: {
        color: 'white'
      },
      itemWidth: v.fontSizeRem(0.4),
      right: 0
    },
    xAxis: {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          color: 'rgba(255, 255, 255, 0.8)'
          // fontSize: v.fontSizeRem(0.75)
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.4)'
          }
        },
        splitNumber: 4
      },
      {
        type: 'value',
        axisLabel: {
          color: 'rgba(255, 255, 255, 0.8)'
          // fontSize: v.fontSizeRem(0.75)
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.4)'
          }
        },
        alignTicks: true,
        splitNumber: 4
      }
    ],
    series: [
      {
        name: '日均查询次数',
        data: [],
        type: 'bar',
        smooth: true,
        symbol: 'none',
        yAxisIndex: 0
      },
      {
        name: '平均每次查询时长/min',
        data: [],
        type: 'line',
        smooth: true,
        symbol: 'none',
        yAxisIndex: 1
      }
    ]
  }
  options.xAxis.data = data?.dailyCountList?.date ?? [111]
  options.series[0].data = data?.dailyCountList?.data ?? []
  options.series[1].data = data?.queryAvgList?.data ?? []
  return options
}
export function ResearchDevelopmentBugEchartOp ({ v, data }) {
  let options = {
    color: ['#3198f7', 'rgba(255, 95, 165, 1)', 'rgba(0, 114, 255, 1)'],
    grid: {
      left: '5%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      data: data?.bugRate?.date ?? [],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: {
      name: '%',
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.4)'
        }
      }
    },
    series: [
      {
        name: 'BUG率',
        data: data?.bugRate?.data.map(item => {
          if (item === null) { return null }
          return (item * 100).toFixed(2)
        }) ?? [],
        type: 'line',
        smooth: true,
        symbol: 'none'
      }
      // {
      //   name: 'HIVE',
      //   data: [1820, 432, 201, 534, 1290, 1330, 1720],
      //   type: 'line',
      //   smooth: true,
      //   symbol: 'none'
      // }
    ]
  }
  return options
}

export function IndexStabilityEchartOp ({ v, data }) {
  let options = {
    color: ['rgba(255, 95, 165, 1)', 'rgba(0, 114, 255, 1)'],
    grid: {
      left: '5%',
      top: '23%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['预警次数'],
      textStyle: {
        color: 'white'
      },
      itemWidth: v.fontSizeRem(0.4),
      right: 0
    },
    xAxis: {
      type: 'category',
      data: [...(data?.date ?? [])],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          color: 'rgba(255, 255, 255, 0.8)'
          // fontSize: v.fontSizeRem(0.75)
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.4)'
          }
        },
        splitNumber: 4
      }
    ],
    series: [
      {
        name: '预警次数',
        type: 'line',
        smooth: true,
        data: [...(data?.data ?? [])]
      }
    ]
  }
  return options
}
